import axiosInstance from '@/plugins/axios';

// Certidão Federal via BFF egov-esocial-api (persistência + agnaldo).
export default class ServiceCertidaoFederal {
  static sincronizar = (cnpj) => axiosInstance.post('certidao-federal/sincronizar', { cnpj });

  static search = (body) => axiosInstance.post('certidao-federal/search', body);

  static dashboard = () => axiosInstance.get('certidao-federal/dashboard');

  static salvar = (body) => axiosInstance.post('certidao-federal', body);

  static atualizar = (id, body) => axiosInstance.put(`certidao-federal/${id}`, body);

  static excluir = (id) => axiosInstance.delete(`certidao-federal/${id}`);

  static historico = (id, body) => axiosInstance.post(`certidao-federal/${id}/historico`, body);

  // Export: enfileira um export persistido (report_process) — não retorna binário.
  static exportData = (body) => axiosInstance.post('certidao-federal/export', body ?? {});

  static downloadUrl = (key) =>
    axiosInstance.get(`storage/download-url?key=${encodeURIComponent(key)}`);

  static uploadArquivo = (file, key) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('key', key);
    return axiosInstance.post('storage/upload', fd);
  };
}

// enum tipo -> label da tela
export const TIPO_LABEL = {
  CND: 'Certidão Negativa',
  CPEN: 'Certidão Positiva com Efeitos de Negativa',
  INDISPONIVEL: 'Indisponível',
  DESABILITADA: 'Coleta Desabilitada',
};

const emailSuporte = import.meta.env.VITE_APP_SUPORTE_AGNES || '';

// codigoRetorno -> "Orientações Agnes" (porte fiel do i18n legado certificate.status.*.orientation)
export const ORIENTACAO_LABEL = {
  COLETA_DESABILITADA: `A coleta de certidões para este CNPJ esta desabilitada. Caso tenha dúvidas ou deseje habilitar contate nosso time em ${emailSuporte}.`,
  CERTIDAO_INDISPONIVEL: `Não foi possível emitir a certidão. Realizaremos novas tentativas de coleta. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.`,
  CERTIDAO_ENCONTRADA:
    'Certidão emitida com sucesso, você pode baixá-la no ícone de download no menu de ações.',
  CERTIDAO_EMITIDA:
    'Certidão emitida com sucesso, você pode baixá-la no ícone de download no menu de ações.',
  CERTIDAO_NAO_EMITIDA: `Não foi possível emitir a certidão, consulte o relatório de situação fiscal para visualizar as pendências sinalizadas pela RFB. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.`,
  SITUACAO_CADASTRAL_IMPEDITIVA: `Não foi possível emitir a certidão, foi sinalizado a existência de situação cadastral impeditiva. Entre em contato com nossos especialistas mediante ${emailSuporte}.`,
  ANALISE_INCONSISTENTE: `Não foi possível emitir a certidão, foi sinalizado que durante a tentativa de emissão estava ocorrendo alguma atualização de base de dados da RFB. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.`,
  BASE_APOIO_INDISPONIVEL: `Não foi possível emitir a certidão, foi sinalizado a indisponibilidade de um dos sistemas necessários para a emissão de certidão durante o processamento da requisição. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.`,
  EM_PROCESSAMENTO: `Não foi possível emitir a certidão, foi sinalizado instabilidade sistêmica durante o processamento do pedido de emissão da certidão. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.`,
};
